$(".product-media-modal__content").slick({
  dots: false,
  infinite: true,
  arrows: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [],
  // Callback to check if the current slide is the last
  afterChange: function (event, slick, currentSlide) {
    if (currentSlide === slick.slideCount - 1) {
      // Disable arrows to prevent scrolling past the last slide
      $(".slick-prev, .slick-next").addClass("slick-disabled");
    } else {
      // Enable arrows for navigation
      $(".slick-prev, .slick-next").removeClass("slick-disabled");
    }
  },
});

$("#Slider-template--18221201522918__testinomials_Uz4XyM").slick({
  dots: false,
  infinite: true,
  autoplay: true,
  speed: 300,
  slidesToShow: 3, // Show only one product
  slidesToScroll: 1, // Scroll one product at a time
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2, // One product for larger screens
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1, // One product for medium screens
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1, // One product for smaller screens
        slidesToScroll: 1,
      },
    },
  ],
});

$(".recommended-product-slider .grid.product-grid").slick({
  dots: false,
  infinite: false,
  speed: 300,
  slidesToShow: 1, // Show only one product
  slidesToScroll: 1, // Scroll one product at a time
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1, // Show one product for wider screens
        slidesToScroll: 1,
        infinite: false,
        dots: false,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1, // Show one product for medium screens
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1, // Show one product for smaller screens
        slidesToScroll: 1,
      },
    },
  ],
});
